import { Node } from "slate";

/**
 *  Serializes Slate JSON to Plaintext
 */
export function serializeToPlainText(nodes: Node[]) {
  return nodes.map((n) => Node.string(n)).join("\n");
}
